"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Germany = void 0;
exports.Germany = {
    id: 'germany',
    companyName: 'Germany',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: false,
        realm: 'germany',
    },
    isInternal: true,
    isActive: true,
    countries: ['DE'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2VybWFueS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9HZXJtYW55LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsT0FBTyxHQUFVO0lBQzFCLEVBQUUsRUFBRSxTQUFTO0lBQ2IsV0FBVyxFQUFFLFNBQVM7SUFDdEIsY0FBYyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3ZCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxLQUFLO1FBQ2xCLEtBQUssRUFBRSxTQUFTO0tBQ25CO0lBQ0QsVUFBVSxFQUFFLElBQUk7SUFDaEIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9